(() => {
  const draftThemeId = document.body.dataset.npThemeId || '192632619307';
  const isPublishedTheme = ['main', 'live'].includes(document.body.dataset.npThemeRole);
  const previewIsActive = () => !isPublishedTheme && (new URL(location.href).searchParams.get('preview_theme_id') === draftThemeId || Boolean(document.getElementById('PBarNextFrame')));
  const previewURLForLink = link => {
    if (!link || link.hasAttribute('download')) return null;
    const raw = link.getAttribute('href');
    if (!raw || raw.startsWith('#')) return null;
    let url;
    try { url = new URL(raw, location.href); } catch { return null; }
    if (!['http:', 'https:'].includes(url.protocol) || url.origin !== location.origin) return null;
    if (/\/(checkout|account|customer_authentication|admin)(\/|$)/.test(url.pathname)) return null;
    if (url.pathname === location.pathname && !url.search && url.hash) return null;
    url.searchParams.set('preview_theme_id', draftThemeId);
    return url;
  };
  const keepPreviewOnNavigation = () => {
    if (!previewIsActive()) return;
    const address = new URL(location.href);
    if (!address.searchParams.has('preview_theme_id')) {
      address.searchParams.set('preview_theme_id', draftThemeId);
      history.replaceState(history.state, '', address.href);
    }
    // Carry the draft in the actual href before browsers, apps or card handlers cache it.
    document.querySelectorAll('a[href]').forEach(link => {
      const url = previewURLForLink(link);
      if (url && link.href !== url.href) link.href = url.href;
    });
    document.querySelectorAll('form').forEach(form => {
      if ((form.method || 'get').toLowerCase() !== 'get') return;
      const action = new URL(form.action || location.href, location.href);
      if (action.origin !== location.origin) return;
      if (/\/(checkout|account|customer_authentication|admin)(\/|$)/.test(action.pathname)) return;
      if (!form.querySelector('input[name="preview_theme_id"]')) {
        const input = document.createElement('input');
        input.type = 'hidden'; input.name = 'preview_theme_id'; input.value = draftThemeId;
        form.append(input);
      }
      const view = new URL(location.href).searchParams.get('view');
      if (view && action.pathname === location.pathname && !form.querySelector('input[name="view"]')) {
        const input = document.createElement('input');
        input.type = 'hidden'; input.name = 'view'; input.value = view;
        form.append(input);
      }
    });
  };
  // Shopify removes the preview query from the address bar. Carry it into subsequent storefront navigation.
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!previewIsActive()) return;
    const url = previewURLForLink(link);
    if (url) link.href = url.href;
  }, true);
  document.addEventListener('submit', keepPreviewOnNavigation, true);
  document.addEventListener('input', keepPreviewOnNavigation, true);
  document.addEventListener('change', event => {
    keepPreviewOnNavigation();
    const form = event.target.closest('.np-sort-form');
    if (form && event.target.tagName === 'SELECT') {
      keepPreviewOnNavigation();
      form.requestSubmit();
    }
  });
  let frameObserved = false;
  const observer = new MutationObserver(() => {
    if (!frameObserved && document.getElementById('PBarNextFrame')) {
      frameObserved = true;
      keepPreviewOnNavigation();
      observer.disconnect();
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  keepPreviewOnNavigation();
  document.addEventListener('DOMContentLoaded', keepPreviewOnNavigation, { once: true });
  document.addEventListener('shopify:section:load', keepPreviewOnNavigation);
})();
